// Remember to also setup new endpoints in the the gatsby proxy config for local development.
// packages/web-app-test-a-bemer/gatsby-config.js
export const API_ENDPOINTS = {
  BEMER_TESTEN: '/api',
  PARTNER_FINDER: '/address',
  PARTNER_FINDER_BY_NAME: '/graphql/',
  TAXID_VALIDATION: '/validation',
};
